import { css } from '@emotion/css';

const layoutStyles = {
    wrap: css`
        display: flex;
        flex-direction: column;
        height: 100%;
    `,
    body: css`
        flex: 1;
    `,
};
export default layoutStyles;
